import React from 'react';
import TooltipModal, { TooltipContent, TooltipHeader } from './index';

export default function TabbFeesTooltip() {
  return (
    <TooltipModal>
      <TooltipHeader>Fatsoma Tabb Fee</TooltipHeader>
      <TooltipContent>
        <p>
          <b>Enable this</b> to pass our fee on to your customers. They'll see
          it added to their order when they checkout.
        </p>
        <p>
          <b>Disable this</b> to pay our fee yourself, for every customer order.
        </p>
      </TooltipContent>
    </TooltipModal>
  );
}



// WEBPACK FOOTER //
// ./src/components/Utility/TooltipModal/TabbFeesTooltip.jsx